import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Nav from "@/components/Nav";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminPhotographs from "@/pages/admin/AdminPhotographs";
import AdminRelationships from "@/pages/admin/AdminRelationships";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminHealthPage from "@/pages/admin/AdminHealthPage";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import { useLenis } from "@/hooks/useLenis";

function Shell() {
  useLenis();
  return (
    <div className="App">
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/explore/:id" element={<Explore />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* Legacy path — redirect to the new Gallery. */}
        <Route path="/photographs" element={<Navigate to="/gallery" replace />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="photographs" replace />} />
          <Route path="photographs" element={<AdminPhotographs />} />
          <Route path="relationships" element={<AdminRelationships />} />
          <Route path="submissions" element={<AdminSubmissions />} />
          <Route path="health" element={<AdminHealthPage />} />
          <Route path="password" element={<AdminChangePassword />} />
        </Route>
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
